import {buildURL} from '@/utils/urlBuilder';

// Get base namespace from centralized URL patterns
const getStoriesNamespace = () => {
    try {
        // Use the dedicated stories namespace URL pattern
        return buildURL('storiesNamespace');
    } catch (error) {
        // Fallback to window.URLS if buildURL is not available
        return window.URLS?.storiesNamespace || '/app/stories';
    }
};

const storiesNamespace = getStoriesNamespace();

// Relative routes for stories namespace
const myStoriesViewRelative = '/my-stories';
const sharedStoriesViewRelative = '/shared-stories';
const storyTemplatesViewRelative = '/story-templates';
const storyboardViewRelative = '/boards/:activeStoryboardHashid/:activeStoryboardUrl';
const storyboardTemplateViewRelative = '/template/:activeStoryUrl/:activeStoryboardUrl';

const storyboardRoutesRelative = [
    '/boards/:activeStoryboardHashid/*',
    storyboardViewRelative,
    '/boards/:activeStoryboardHashid/:activeStoryboardUrl/:activeStoryUrl/:activeStoryObject',
    storyboardTemplateViewRelative,
    '/template/:activeStoryUrl/:activeStoryboardUrl/:activeStoryObject',
];

// Absolute routes using centralized URL patterns with buildURL
const getMyStoriesViewRoute = () => {
    try {
        return buildURL('myStoriesView');
    } catch (error) {
        return window.URLS?.myStoriesView || `${storiesNamespace}${myStoriesViewRelative}`;
    }
};

const getSharedStoriesViewRoute = () => {
    try {
        return buildURL('sharedStoriesView');
    } catch (error) {
        return window.URLS?.sharedStoriesView || `${storiesNamespace}${sharedStoriesViewRelative}`;
    }
};

const getStoryTemplatesViewRoute = () => {
    try {
        return buildURL('storyTemplatesView');
    } catch (error) {
        return window.URLS?.storyTemplatesView || `${storiesNamespace}${storyTemplatesViewRelative}`;
    }
};

const getStoryboardViewRoute = () => {
    try {
        // Get the base pattern and adapt parameter names for routing
        const basePattern = buildURL('storyStoryboardView', {storyboard_id: ':activeStoryboardHashid', story_id: ':activeStoryboardUrl'});
        return basePattern;
    } catch (error) {
        // Fallback to window.URLS with manual replacement
        if (window.URLS?.storyStoryboardView) {
            return window.URLS.storyStoryboardView
                .replace(':storyboard_id', ':activeStoryboardHashid')
                .replace(':story_id', ':activeStoryboardUrl');
        }
        return '/app/insights/storyboards/:activeStoryboardHashid/:activeStoryboardUrl';
    }
};

const getStoryboardTemplateViewRoute = () => {
    try {
        // Get the base pattern and adapt parameter names for routing
        const basePattern = buildURL('storyboardTemplateView', {assigned_url: ':activeStoryUrl', storyboard_slug: ':activeStoryboardUrl'});
        return basePattern;
    } catch (error) {
        // Fallback to window.URLS with manual replacement
        if (window.URLS?.storyboardTemplateView) {
            return window.URLS.storyboardTemplateView
                .replace(':assigned_url', ':activeStoryUrl')
                .replace(':storyboard_slug', ':activeStoryboardUrl');
        }
        return '/app/insights/storyboards-template/:activeStoryUrl/:activeStoryboardUrl';
    }
};

const getStoryboardRoutes = () => {
    try {
        // Use buildURL to get base patterns and adapt them for routing
        const baseStoryboardView = buildURL('storyStoryboardView', {storyboard_id: ':activeStoryboardHashid', story_id: '*'});
        const baseSpecialObjectView1 = buildURL('specialStoryObjectDetailView', {story_assigned_url: ':activeStoryboardHashid', obj_id: ':activeStoryObject'});
        const baseSpecialObjectView2 = buildURL('specialStoryObjectDetailView', {story_assigned_url: ':activeStoryUrl', obj_id: ':activeStoryObject'});
        
        return [
            baseStoryboardView,
            getStoryboardViewRoute(),
            baseSpecialObjectView1,
            getStoryboardTemplateViewRoute(),
            baseSpecialObjectView2,
        ];
    } catch (error) {
        // Fallback to window.URLS approach
        const baseStoryboardView = window.URLS?.storyStoryboardView;
        const baseSpecialObjectView = window.URLS?.specialStoryObjectDetailView;
        
        return [
            baseStoryboardView?.replace(':storyboard_id', ':activeStoryboardHashid').replace(':story_id', '*') || '/app/insights/storyboards/:activeStoryboardHashid/*',
            getStoryboardViewRoute(),
            baseSpecialObjectView?.replace(':story_assigned_url', ':activeStoryboardHashid').replace(':obj_id', ':activeStoryObject') || '/stories/:activeStoryboardHashid/:activeStoryObject',
            getStoryboardTemplateViewRoute(),
            baseSpecialObjectView?.replace(':story_assigned_url', ':activeStoryUrl').replace(':obj_id', ':activeStoryObject') || '/stories/:activeStoryUrl/:activeStoryObject',
        ];
    }
};

// Computed values (will be evaluated when accessed)
const myStoriesViewRoute = getMyStoriesViewRoute();
const sharedStoriesViewRoute = getSharedStoriesViewRoute();
const storyTemplatesViewRoute = getStoryTemplatesViewRoute();
const storyboardViewRoute = getStoryboardViewRoute();
const storyboardTemplateViewRoute = getStoryboardTemplateViewRoute();
const storyboardRoutes = getStoryboardRoutes();

export const storiesNamespaces = {
    storiesNamespace,
};

export const storiesRelativeRoutes = {
    myStoriesViewRelative,
    sharedStoriesViewRelative,
    storyTemplatesViewRelative,
    storyboardViewRelative,
    storyboardTemplateViewRelative,
};

export const storiesComplexRelativeRoutes = {
    storyboardRoutesRelative,
};

export const storiesAbsoluteRoutes = {
    myStoriesViewRoute,
    sharedStoriesViewRoute,
    storyTemplatesViewRoute,
    storyboardViewRoute,
    storyboardTemplateViewRoute,
};

export const storiesComplexAbsoluteRoutes = {
    storyboardRoutes,
};
